import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';

const getFileNameFromContentDisposition = (contentDisposition) => {
    if (!contentDisposition) {
        return null;
    }

    const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utfMatch?.[1]) {
        return decodeURIComponent(utfMatch[1]);
    }

    const basicMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    return basicMatch?.[1] || null;
};

export const secretMigrationApi = createApi({
    reducerPath: 'secretMigrationApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getConfigurationInventory: builder.query({
            query: () => ({
                url: '/api/secret-migration/config/inventory',
                method: 'GET',
            }),
        }),
        getReprotectionPreview: builder.mutation({
            query: () => ({
                url: '/api/secret-migration/config/reprotection-preview',
                method: 'POST',
            }),
        }),
        getRedactedReprotectionExport: builder.mutation({
            query: ({ changeReferenceId }) => ({
                url: '/api/secret-migration/config/reprotection-export',
                method: 'POST',
                body: { changeReferenceId },
                headers: {
                    'X-Change-Reference-Id': changeReferenceId,
                },
            }),
        }),
        getReprotectionExportCsv: builder.mutation({
            query: ({ changeReferenceId }) => ({
                url: '/api/secret-migration/config/reprotection-export/csv',
                method: 'POST',
                body: { changeReferenceId },
                headers: {
                    'X-Change-Reference-Id': changeReferenceId,
                },
                responseHandler: async (response) => {
                    if (!response.ok) {
                        const contentType = response.headers.get('content-type') || '';
                        if (contentType.includes('application/json')) {
                            return response.json();
                        }

                        return response.text();
                    }

                    return response.blob();
                },
            }),
            transformResponse: (blob, meta) => {
                const contentDisposition = meta?.response?.headers?.get('content-disposition');
                const fileName = getFileNameFromContentDisposition(contentDisposition)
                    || `secret-reprotection-export-${new Date().toISOString().replace(/[:.]/g, '-')}.csv`;

                return { blob, fileName };
            },
        }),
    }),
});

export const {
    useLazyGetConfigurationInventoryQuery,
    useGetReprotectionPreviewMutation,
    useGetRedactedReprotectionExportMutation,
    useGetReprotectionExportCsvMutation,
} = secretMigrationApi;
